var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReelUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1415_6500)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7143 8.78516C13.1482 8.78516 13.5 9.13694 13.5 9.57087V11.928C13.5 12.7959 12.7965 13.4994 11.9286 13.4994H4.07143C3.20355 13.4994 2.5 12.7959 2.5 11.928V9.57087C2.5 9.13694 2.85178 8.78516 3.28571 8.78516C3.71965 8.78516 4.07143 9.13693 4.07143 9.57087V11.928H11.9286V9.57087C11.9286 9.13693 12.2803 8.78516 12.7143 8.78516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00003 9.89648C8.43397 9.89648 8.78575 9.5447 8.78575 9.11077V5.50765L9.8016 6.5235C10.1084 6.83034 10.6059 6.83034 10.9128 6.5235C11.2196 6.21665 11.2196 5.71917 10.9128 5.41233L8.00003 2.49961L5.08731 5.41233C4.78047 5.71917 4.78047 6.21665 5.08731 6.5235C5.39415 6.83034 5.89163 6.83034 6.19848 6.5235L7.21432 5.50765V9.11077C7.21432 9.5447 7.5661 9.89648 8.00003 9.89648Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1415_6500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelUp);
export default __webpack_public_path__ + "static/media/reel-up.49a43a90728febe5dde80bcd2e82e142.svg";
export { ForwardRef as ReactComponent };